/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createCos } from '../../factoriesAny.js';
export var cosDependencies = {
  typedDependencies: typedDependencies,
  createCos: createCos
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesCos.generated.js
// module id = 1511
// module chunks = 0